import React, { FC, useCallback, useEffect } from 'react';

import { useMfaIssueDetailsQuery } from 'src/apps/mfa/hooks/useMfaIssueDetailsQuery';
import { ActionButtons } from 'src/apps/mobile-common/components/action-buttons/ActionButtons';
import { MobileComponentDetailsBlock } from 'src/common/components/mobile-component-details-block/MobileComponentDetailsBlock';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { getBaseURL } from 'src/common/helpers/UrlNormalizingHelper';

interface IMfaComponentDetailsBlockProps {
	issueId: string;
	runId: string;
	scanName: string;
	scanCreatedAt: string;
	issueNumber: string;
	isFullPageMode?: boolean;
	setError?: (error: unknown) => void;
}

export const MfaComponentDetailsBlock: FC<IMfaComponentDetailsBlockProps> = ({
	issueId,
	runId,
	scanName,
	scanCreatedAt,
	issueNumber,
	isFullPageMode,
	setError
}) => {
	const issueDetailsQuery = useMfaIssueDetailsQuery(issueId, runId);

	useEffect(() => {
		if (issueDetailsQuery.isError) {
			setError?.(issueDetailsQuery.error);
		}
	}, [issueDetailsQuery.isError, issueDetailsQuery.error, setError]);

	const issuePageUrl = RoutesHelper.getMfaIssueInfoPath({ runId, issueId });
	const urlToCopy = `${getBaseURL()}${issuePageUrl}`;

	const openIssueInNewTab = useCallback((): void => {
		window.open(issuePageUrl, '_blank');
	}, [issuePageUrl]);

	const actionButtons = !isFullPageMode ? (
		<ActionButtons textToCopy={urlToCopy} openNewTab={openIssueInNewTab} />
	) : null;

	return (
		<MobileComponentDetailsBlock
			isLoading={issueDetailsQuery.isLoading}
			issue={issueDetailsQuery.data}
			scanName={scanName}
			runTime={scanCreatedAt}
			issueNumber={issueNumber}
			actionButtons={actionButtons}
		/>
	);
};
